module.exports = __webpack_public_path__ + "img/colegio_san_miguel_asuncion.db5ed65e.jpg";